import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import type { ProductScoreGaugeProps } from '../../../../ProductScoreGauge'
import { ProductScoreGauge } from '../../../../ProductScoreGauge'
import type { ProsConsProps } from '../../../../ProsCons'
import { ProsCons } from '../../../../ProsCons'
import styles from './ProductCardAdditionalInfo.module.scss'
export const ProductCardAdditionalInfo: FunctionComponent<
  AdditionalInfoProps
> = ({ productScoreGauge, prosConsList, className }) => (
  <div
    className={classnames(styles.additionalInformation, className && className)}
  >
    <div className={styles.score}>
      <ProductScoreGauge
        {...productScoreGauge}
        variant={productScoreGauge.variant}
      />
    </div>
    {prosConsList && (
      <div
        className={classnames(
          styles.prosCons,
          (prosConsList?.pros?.list || prosConsList?.cons?.list) &&
            styles.prosConsBorder
        )}
      >
        <ProsCons isOnlyFirstFeatureDisplayed={true} {...prosConsList?.pros} />
        <ProsCons isOnlyFirstFeatureDisplayed={true} {...prosConsList?.cons} />
      </div>
    )}
  </div>
)

///////// IMPLEMENTATION /////////

export type AdditionalInfoProps = {
  /**
   *  Test score gauge.
   */
  productScoreGauge: ProductScoreGaugeProps
  /**
   *  Pros and cons array.
   */
  prosConsList?: {
    pros?: ProsConsProps | null
    cons?: ProsConsProps | null
  } | null
  /**
   * CSS class name.
   */
  className?: string
}
